// extracted by mini-css-extract-plugin
export default {"wrapper":"OrgSettings_wrapper__CQI9b","content":"OrgSettings_content__qmBgN"};